/**
 * ⚠️ NO LONGER RENDERED — kept only for its child components.
 *
 * Every game moved to the crash-style feed (SocialBetTable for crash,
 * MarbleBetTable for everything else) in the port that replaced the page's
 * `isCrashGame ? <SocialBetTable/> : <SocialList/>` ternary. Nothing mounts
 * this component now.
 *
 * Its CHILDREN are still very much alive — SocialBetPanelView imports
 * `PlayerDetails` and `BetMarbles` from ./components — so do not delete the
 * folder wholesale.
 *
 * Removing this file also makes the store's `topBets` bookkeeping dead (see
 * store/social.ts). Left in place deliberately: deleting a component plus its
 * store plumbing is its own change with its own risk, and it costs nothing at
 * runtime while unmounted. Cleanup ticket, not a bundled one.
 */
import { useRef, useState } from 'react'
import type { Marble } from 'src/types/domain/Marble'
import { useGetSocialTopBets } from 'src/store/social'
import { BetListItems } from './components/BetListItems'
import { BetListHeader } from './components/BetListHeader'

type Props = Readonly<{
  marbles:  Marble[]
}>

export function SocialList({ marbles }: Props) {
  const bets = useGetSocialTopBets()
  const containerRef = useRef<HTMLDivElement>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  if (bets.length === 0) return null

  return (
    <div className="show-players-outer">
      <div
        className={`show-players ${isExpanded ? 'expanded' : 'collapsed'} ${
          bets.length >= 5 ? 'many-bets' : ''
        }`}
        ref={containerRef}
      >
        <BetListHeader isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        <BetListItems marbles={marbles} />
      </div>
    </div>
  )
}
